<template>
  <div v-if="isMounted">
    <!-- PANEL DE CUMPLIMIENTO -->
    <compliance-banner class="mb-4" @loadedRequirements="loadedRequirements" />
    <div v-if="isMounted && mainComplianceRequirements <= 0">
      <!-- SI EL INVERSIONISTA NO ES NIVEL 2 LE PEDIMOS DIRECCION Y VERIFICACION DE IDENTIDAD -->
      <vx-card v-if="contractLevel < 2"
        title="Para poder abonar fondos desde un banco extranjero primero debes indicar tu domicilio y verificar tu identidad.">
        <UploadAddressAndIdentityVerification :show-texts="false" :reload-page="true">
        </UploadAddressAndIdentityVerification>
      </vx-card>
      <vx-card v-else>
        <!-- SI EL INVERSIONISTA YA ES NIVEL 2 SE REVISA SI PUEDE OPERAR CON CUENTAS NACIONALES Y EXTRANJERAS  -->
        <vs-tabs v-if="bankOrigin == bankOriginBoth" v-model="activeTab">
          <vs-tab label="Cuenta internacional">
            <div class="tab-text">
              <!-- SI YA TIENE CUENTAS BANCARIAS SE MUESTRA LA INFO DE RG -->
              <template v-if="validAccounts.length > 0">
                <!-- INFO DE RG PARA TRANSFERENCIAS INTERNACIONALES -->
                <rg-international-account-info></rg-international-account-info>
              </template>
              <!-- SI AUN NO CUENTA CON CUENTAS SE MUESTRA EL FORM PARA QUE PUEDA DARLAS DE ALTA -->
              <template v-else>
                <vs-alert v-if="accountsInValidation.length > 0" icon-pack="feather" icon="icon-info" color="dark">
                  <span>Tienes cuentas de banco en validación consultalas en la sección <strong>"Banco"</strong> de tu
                    <strong>"Perfíl"</strong></span>
                </vs-alert>
                <international-bank-accounts class="mt-4" :is-moral="false" :person-type="2" :user-id="UserId"
                  :has-backoffice-access="false" :user-data="base" :only-form="true" />
              </template>
            </div>
          </vs-tab>
          <vs-tab label="Cuenta nacional">
            <div class="tab-text">
              <stp-account-info class="mt-4" :user_id="UserId" :stpClabe="stpClabe" />
            </div>
          </vs-tab>
        </vs-tabs>
        <div v-else-if="bankOrigin == bankOriginMexico" class="vx-row">
          <div class="vx-col w-full">
            <!-- PROCESAMIENTO CON STP -->
            <stp-account-info :user_id="UserId" :stpClabe="stpClabe" />
            <!-- FIN PROCESAMIENTO CON STP -->
          </div>
        </div>
        <div v-else-if="bankOrigin == bankOriginForeign">
          <!-- SI YA TIENE CUENTAS BANCARIAS SE MUESTRA LA INFO DE RG -->
          <template v-if="validAccounts.length > 0">
            <!-- INFO DE RG PARA TRANSFERENCIAS INTERNACIONALES -->
            <rg-international-account-info></rg-international-account-info>
          </template>
          <!-- SI AUN NO CUENTA CON CUENTAS SE MUESTRA EL FORM PARA QUE PUEDA DARLAS DE ALTA -->
          <template v-else>
            <vs-alert v-if="accountsInValidation.length > 0" icon-pack="feather" icon="icon-info" color="dark">
              <span>Tienes cuentas de banco en validación consultalas en la sección <strong>"Banco"</strong> de tu
                <strong>"Perfíl"</strong></span>
            </vs-alert>
            <international-bank-accounts class="mt-4" :is-moral="false" :person-type="2" :user-id="UserId"
              :has-backoffice-access="false" :user-data="base" :only-form="true" />
          </template>
        </div>
      </vx-card>
      <!-- CARD PARA REGISTRAR UN ABONO INTERNACIONAL -->
      <template v-if="showRegisterInternationalFundsCard">
        <vx-card class="mt-base" title="Registra tu abono" v-show="activeTab == 0">
          <p>Una vez que hayas realizado la transferencia, ingresa la siguiente información y sube tu comprobante.</p>
          <register-international-fund class="mt-5" :user-accounts-prop="userAccounts"
            :user-data-base="base"></register-international-fund>
        </vx-card>
      </template>
    </div>
  </div>
</template>

<script>
import ComplianceBanner from "@components/compliance/ComplianceBanner";
import ContractLevelsInfo from "@components/investor/contract-levels/ContractLevelsInfo";
import UploadAddressAndIdentityVerification from "@components/investor/contract-levels/UploadAddressAndIdentityVerification";
import { mapState } from "vuex";
import BankOriginEnum from "@/modules/enums/BankOriginEnum";
import StpAccountInfo from "@components/stp/StpAccountInfo";
import stpHelper from "@mixins/stpHelper";
import InternationalBankAccounts from "@components/investor/bank-accounts/InternationalBankAccounts";
import InvestorInfoHelper from "@/helpers/investorInfoHelper";
import RegisterInternationalFund from "@components/investor/bank-accounts/RegisterInternationalFund";
import RgInternationalAccountInfo from "@components/stp/RgInternationalAccountInfo.vue";
import { BankAccountStatus } from "@/bl/BankAccountStatus";

export default {
  components: { ContractLevelsInfo, UploadAddressAndIdentityVerification, ComplianceBanner, StpAccountInfo, InternationalBankAccounts, RegisterInternationalFund, RgInternationalAccountInfo },
  mixins: [BankOriginEnum, stpHelper, InvestorInfoHelper],
  data() {
    return {
      activeTab: 0,
      bankOriginMexico: BankOriginEnum.MEXICO,
      bankOriginBoth: BankOriginEnum.AMBAS,
      bankOriginForeign: BankOriginEnum.EXTRANJERO,
      isMounted: false,
      requirements: null,
      mainComplianceRequirements: 0,
      mexicoCountryId: 700,
      // selectedAccountId: null,
      contractLevelData: null,
      stpClabe: null,
      base: [],
      userAccounts: [],
      validAccounts: [],
      accountsInValidation: [],
    }
  },
  computed: {
    ...mapState("auth", ["roleGeneralData"]),
    contractLevel() {
      return this.contractLevelData.contract_level;
    },
    bankOrigin() {
      return this.roleGeneralData.bank_origin;
    },
    showRegisterInternationalFundsCard() {
      if (this.contractLevel < 2) {
        return false;
      }
      if (this.bankOrigin == this.bankOriginMexico) {
        return false;
      }
      if (this.validAccounts.length <= 0) {
        return false;
      }
      return true;
    }
  },
  async mounted() {
    this.showLoading(true)
    this.isMounted = false
    await this.getInvestorContractLevelData(this.InvestorId);
    await this.getUserAccounts();
    if (this.bankOrigin == this.bankOriginBoth || this.bankOrigin == this.bankOriginMexico) {
      await this.checkForStpInfo();
    }
    if (this.bankOrigin == this.bankOriginBoth || this.bankOrigin == this.bankOriginForeign) {
      const requiredObjects = ['user.personal', 'user.business.personal'];
      this.base = await this.getInvestorData(this.InvestorId, requiredObjects);
    }
    this.isMounted = true
    this.showLoading(false)
  },
  methods: {
    async getInvestorContractLevelData() {
      try {
        let res = await axios.get('/api/v2/investor/' + this.InvestorId + '/getContractLevelData');
        this.contractLevelData = res.data;
      } catch (error) {
      }
    },
    // solicitar informacion de stp solo si corresponde
    async checkForStpInfo() {
      this.stpClabe = await this.getInvestorAccountStpClabe(this.InvestorId);
    },
    loadedRequirements(count) {
      this.mainComplianceRequirements = count;
    },
    async getUserAccounts() {
      try {
        const res = await axios.get('api/app/bank-account');
        const accs = res.data;
        // let formattedAccounts = [];
        // accs.forEach(f => {
        //   let nacc = this.getFormattedAccount(f);
        //   formattedAccounts.push(nacc);
        // });
        this.accountsInValidation = accs.filter(f => f.verified == BankAccountStatus.VERIFIED_REQUESTED);
        this.validAccounts = accs.filter(f => f.verified == BankAccountStatus.VERIFIED);
        this.userAccounts = accs;
        // this.validAccounts.sort(function(a, b) {
        //   if(a.is_default){
        //     return -1
        //   }
        //   else if(b.is_default){
        //     return 1;
        //   }
        //   return 0;
        // });

        // this.validAccounts.forEach(opt => {
        //   this.accounts.push({value: parseInt(opt.id), label: `${opt.bank_name} | ${opt.clabe}`}); //conversion a sintaxis de vx-select
        // })

        // const defaultAccount = this.validAccounts.find(f => f.is_default);
        // if(defaultAccount != null){
        //   this.selectedAccountId = defaultAccount.id;
        // }
      }
      catch (e) {
      }
    },
    // getFormattedAccount(f){
    //   let nacc = {
    //     id: f.id,
    //     bank_id: f.bank_id,
    //     is_default: f.is_default === 1,
    //     is_verified: f.verified === BankAccountStatus.VERIFIED,
    //   }

    //   if(f.bank && f.bank.country_id === this.mexicoCountryId){
    //     nacc.bank_name = f.bank.short_name;
    //     nacc.clabe = f.clabe;
    //   }
    //   else {
    //     nacc.bank_name = f.bank.name;
    //     nacc.clabe = f.bic_swift;
    //   }
    //   return nacc;
    // },
  }
}
</script>

<style lang="css">
.voucher-box {
  border: 2px solid rgba(var(--vs-rgblack), 1);
  border-radius: 6px;
  padding: .68rem 0.75rem;
}

.vs-progress--background {
  background-color: #92B9B0 !important;
}

.regular {
  font-family: "gilroyregular" !important;
  font-weight: normal;
  line-height: 1.2;
  color: #2c2c2c;
}

.vx-card.border-primary {
  border-style: solid;
  border-width: 2px;
}
</style>

<style lang="scss">
#data-list-card-view-funds {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 10px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }

          &.img-container {

            span {
              display: flex;
              justify-content: flex-start;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
